import { Injectable } from '@angular/core';
import { PartnerServiceInterface } from '@galaxy/partner';
import { AppConfig, AppConfigService } from './app-config.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class PartnerService implements PartnerServiceInterface {
  constructor(private appConfigService: AppConfigService) {}

  public getPartnerId(): Observable<string> {
    return this.appConfigService.appConfig.pipe(map((config: AppConfig) => config.partnerId));
  }
}
